module.exports = __webpack_public_path__ + "img/svg/energy-drink-stats.49452d95df553d5d1a2b88726eec9dc2.svg";